import {useRef} from "react";
import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {AccountSubscriptionType} from "@/lib/types/accounts.ts";
import {LimitCheckLocationTierLimit} from "@/pages/billing/v2/InstantCheckout/LimitCheckLocationTierLimit.tsx";
import {LimitCheckerComponent} from "@/pages/billing/v2/InstantCheckout/LimitCheckWithInstantCheckout.tsx";

interface UpgradeButtonProps {
  billingType: AccountSubscriptionType;
  groupId: number;
}

export const UpgradeButton = ({billingType, groupId}: UpgradeButtonProps) => {
  const ref = useRef<LimitCheckerComponent>();

  if (billingType === AccountSubscriptionType.BILLING_1_0) {
    return (
      <Button as={Link} to="/billing" variant="secondary" size="extraSmall" className={"me-2"}>
        Upgrade
      </Button>
    );
  }

  const onClick = async () => {
    if (groupId) {
      await ref.current?.checkIfLimitHit({
        limitField: "limit_monitoring_group_level",
        requestedValue: groupId,
      });
      return;
    }
    await ref.current?.checkIfLimitHit();
  };

  return (
    <>
      <LimitCheckLocationTierLimit ref={ref} />
      <Button variant="secondary" onClick={onClick} size="small">
        Upgrade
      </Button>
    </>
  );
};
